var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraCardIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9735 13.1407H4.02791C2.8311 13.1407 1.85742 12.1671 1.85742 10.9702V4.02468C1.85742 2.82787 2.8311 1.85419 4.02791 1.85419H10.9735C12.1703 1.85419 13.144 2.82787 13.144 4.02468V10.9702C13.144 12.1671 12.1703 13.1407 10.9735 13.1407Z",
    fill: "url(#paint0_linear_1389_9162)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4584 8.23669C10.9518 7.72966 10.127 7.72966 9.6204 8.23669L8.67406 9.18302C8.50563 9.35145 8.23172 9.35145 8.06372 9.18302L6.24919 7.36849C5.7426 6.86146 4.91781 6.86146 4.41122 7.36849L1.85742 9.92229V10.9702C1.85742 12.167 2.8311 13.1407 4.02791 13.1407H10.9735C12.1703 13.1407 13.144 12.167 13.144 10.9702V9.92229L11.4584 8.23669Z",
    fill: "url(#paint1_linear_1389_9162)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.45464 6.62925C10.1739 6.62925 10.7569 6.04619 10.7569 5.32695C10.7569 4.60772 10.1739 4.02466 9.45464 4.02466C8.7354 4.02466 8.15234 4.60772 8.15234 5.32695C8.15234 6.04619 8.7354 6.62925 9.45464 6.62925Z",
    fill: "url(#paint2_linear_1389_9162)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1389_9162",
    x1: 7.5007,
    y1: 1.98138,
    x2: 7.5007,
    y2: 8.88657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4793EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635,
    stopColor: "#2367EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#294CCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1389_9162",
    x1: 7.5007,
    y1: 6.92528,
    x2: 7.5007,
    y2: 13.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AFF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#35B97D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1389_9162",
    x1: 8.53392,
    y1: 4.40623,
    x2: 10.3754,
    y2: 6.24767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.272,
    stopColor: "#FDCE01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.528,
    stopColor: "#FBC205"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776,
    stopColor: "#F8B00C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F59815"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraCardIcon1);
export default __webpack_public_path__ + "static/media/camera_card_icon1.ca0723305584f6ed235491397e6551af.svg";
export { ForwardRef as ReactComponent };